import { apiClient } from "../config";

async function getSummaryReports(id: any) {
  const res = await apiClient.get(`/admin/reports/${id}/summary`);
  return res.data;
}

export default getSummaryReports;
